// Single source of truth for on-screen date display across the portal —
// every page used to duplicate its own formatDate/fmtDate helper with
// inconsistent output (DD Mon YYYY, DD-Mon-YY, DD Mon YY, long weekday
// form, or raw unformatted ISO). All data-field dates now render dd/mm/yyyy.
export function formatDate(v) {
    if (!v) return '—';
    const s = String(v).slice(0, 10);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
    const d = new Date(v);
    if (isNaN(d.getTime())) return '—';
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
}

// For export filenames (e.g. "PO_export_28-10-2026.xlsx") — same dd-mm-yyyy
// convention, hyphenated since filenames can't contain slashes.
export function formatDateForFilename(v) {
    const formatted = formatDate(v ?? new Date());
    return formatted === '—' ? '' : formatted.replace(/\//g, '-');
}
